"use strict";
const FormsyFields = require('formsy-react-components');

FormsyFields.FormsyReactComponent = require('formsy-react-components/release/hoc/component').default;
FormsyFields.Help = require('formsy-react-components/release/components/help').default;
FormsyFields.ErrorMessages = require('formsy-react-components/release/components/error-messages').default;
FormsyFields.Info = require('formsy-react-components/release/components/info').default;
FormsyFields.Footer = require('formsy-react-components/release/components/footer').default;

export default FormsyFields;